import React from 'react';
import styled from 'styled-components';
import Markdown from '@common/Node/CompletionChatbot/Markdown';

import { Button, Modal } from '@common/index';
import { Stack } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { flowActions } from '@store/slices';
import { AppDispatch, State } from '@store/index';
import { InfoOutlined } from '@mui/icons-material';
import { useTheme } from '../../styles/theme';
import { getIcon } from '@common/Node';

const MarkdownContainer = styled.div`
  font-size: 14px;

  h4 {
    margin-top: 1rem;
    margin-bottom: 0.25rem;
  }

  h3 {
    font-size: 20px;
    margin-bottom: 1rem;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.primary};

    code {
      font-size: 18px;
    }
  }

  code {
    font-size: 14px;
  }

  li {
    margin-top: 0.5rem;
  }
`;

export const NodeChangelog: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const theme = useTheme();

  const currentTheme = useSelector((state: State) => state.flow.theme);
  const nodeChangelog = useSelector((state: State) => state.flow.showNodeChangelog);
  const open = Boolean(nodeChangelog);
  const setOpen = () => dispatch(flowActions.setShowNodeChangelog(null));

  const nodeTitle = nodeChangelog?.title;
  const changelog = nodeChangelog?.changelog || 'This node does not have any recorded changes.';
  const background = nodeChangelog?.background;
  const parsedBackground =
    background === '#000000' && currentTheme === 'dark' ? theme.background.light : background || theme.primary;

  return (
    <Modal
      open={Boolean(open)}
      setOpen={setOpen}
      header={`${nodeTitle} - Change Log`}
      background={parsedBackground || theme.primary}
      identifier={`v${nodeChangelog?.version || '1.0'}`}
      icon={nodeChangelog?.icon ? getIcon(nodeChangelog.icon) : <InfoOutlined />}
      info='This document explains the various upgrades that have been applied to this node.'
      body={
        <MarkdownContainer>
          <Markdown content={changelog} />
        </MarkdownContainer>
      }
      actions={
        <Stack direction='row' spacing={1}>
          <Button small customColor='primary' onClick={setOpen}>
            Close
          </Button>
        </Stack>
      }
    />
  );
};
